import {
    GET_CUSTOMER_LIST,
    GET_SELECTED_CUSTOMER,
    GET_QLOAD_CUSTOMER_LIST
} from '../actions/types';


const INITIAL_STATE = {
    customerList: [],
    selectedCustomer: null,
    qloadCustomerList: []
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case GET_CUSTOMER_LIST:
            return { ...state, customerList: action.payload };
        case GET_SELECTED_CUSTOMER:
            return { ...state, selectedCustomer: action.payload };
        case GET_QLOAD_CUSTOMER_LIST:
            return { ...state, qloadCustomerList: action.payload };
        default:
            return state;
    }


}
